import type { ContentfulFaqWrapFragment } from '@/graphql/contentful/api';

import { renderContentfulFaqSection } from './cms';

interface OtherFaqType {
  isFromFaqWrapCategories?: boolean;
  withJsonLd?: boolean;
}

export type FaqWrapProps = ContentfulFaqWrapFragment & OtherFaqType;
export const FaqWrap = (props: FaqWrapProps) => {
  if (props) {
    return renderContentfulFaqSection({
      ...props,
      isFromFaqWrapCategories: props?.isFromFaqWrapCategories,
      withJsonLd: props?.withJsonLd,
    });
  } else {
    return null;
  }
};
